<template>
  <article>
    <div v-for="(fn, idx) of hotpaths" :key="idx">
      <SingleFunctionCard :data-v-demo-fn="idx" :fn="fn" />
    </div>
  </article>
</template>

<script>
import SingleFunctionCard from "@/components/SingleFunctionCard";

export default {
  name: "FunctionCards",
  components: {
    SingleFunctionCard
  },
  props: {
    hotpaths: {
      type: Array,
      required: true
    }
  }
};
</script>
